// THIS FILE IS AUTO-GENERATED — do not edit by hand.
// Re-generate with: yarn workspace @portal/rocket-api-client generate:maps

export const REL_MAP: Record<string, string> = {
  listInstalledPlugins: 'list_installed_plugins',
  createPartnerAccount: 'create_partner_account',
  createPartnerAccountHostingPlan: 'create_partner_account_hosting_plan',
  listPartnerProducts: 'list_partner_products',
  createPartnerSite: 'create_partner_site',
  modifyPartnerSite: 'modify_partner_site',
  createPartnerSiteAiBuilderSession: 'create_partner_site_ai_builder_session',
  suspendPartnerSite: 'suspend_partner_site',
  unsuspendPartnerSite: 'unsuspend_partner_site',
  reportOnAccountBandwidth: 'report_on_account_bandwidth',
  generateAccountBillingSso: 'generate_account_billing_sso',
  cancelAccount: 'cancel_account',
  generateFeatureRequestSso: 'generate_feature_request_sso',
  findAccountHostingPlan: 'find_account_hosting_plan',
  createAccountHostingPlan: 'create_account_hosting_plan',
  updateAccountHostingPlan: 'update_account_hosting_plan',
  listAccountInvites: 'list_account_invites',
  deleteAccountInvite: 'delete_account_invite',
  findAccountMe: 'find_account_me',
  modifyAccountMe: 'modify_account_me',
  changeAccountPassword: 'change_account_password',
  listAccountTasks: 'list_account_tasks',
  findAccountUsage: 'find_account_usage',
  listAccountVisitors: 'list_account_visitors',
  listAccounts: 'list_accounts',
  listMyAccountInvites: 'list_my_account_invites',
  switchAccount: 'switch_account',
  listBillingAddresses: 'list_billing_addresses',
  createBillingAddress: 'create_billing_address',
  findBillingAddress: 'find_billing_address',
  modifyBillingAddress: 'modify_billing_address',
  deleteBillingAddress: 'delete_billing_address',
  listBillingEmails: 'list_billing_emails',
  findBillingEmail: 'find_billing_email',
  listBillingInvoices: 'list_billing_invoices',
  findBillingInvoice: 'find_billing_invoice',
  payBillingInvoiceCreditCardPayment: 'pay_billing_invoice_credit_card_payment',
  createBillingInvoicePaypalSubscription: 'create_billing_invoice_paypal_subscription',
  confirmBillingInvoicePaypalSubscription: 'confirm_billing_invoice_paypal_subscription',
  downloadBillingInvoicePdf: 'download_billing_invoice_pdf',
  listBillingPaymentMethods: 'list_billing_payment_methods',
  createBillingPaymentMethod: 'create_billing_payment_method',
  createBillingPaymentMethodCreditCardSetupIntent:
    'create_billing_payment_method_credit_card_setup_intent',
  findBillingPaymentMethod: 'find_billing_payment_method',
  modifyBillingPaymentMethod: 'modify_billing_payment_method',
  deleteBillingPaymentMethod: 'delete_billing_payment_method',
  listBillingProducts: 'list_billing_products',
  login: 'login',
  checkPasswordStrength: 'check_password_strength',
  reportOnSiteBandwidthTopUsage: 'report_on_site_bandwidth_top_usage',
  reportOnReportingSiteBandwidthUsage: 'report_on_reporting_site_bandwidth_usage',
  reportOnSiteCdnCacheContent: 'report_on_site_cdn_cache_content',
  reportOnSiteCdnCacheStatus: 'report_on_site_cdn_cache_status',
  reportOnSiteCdnCacheTopDeprecated: 'report_on_site_cdn_cache_top_deprecated',
  reportOnSiteCdnRequests: 'report_on_site_cdn_requests',
  reportOnSiteVisitors: 'report_on_site_visitors',
  reportOnSiteWafEventlist: 'report_on_site_waf_eventlist',
  reportOnSiteWafEventsDeprecated: 'report_on_site_waf_events_deprecated',
  reportOnSiteWafEventsServicesDeprecated: 'report_on_site_waf_events_services_deprecated',
  reportOnSiteWafEventsSource: 'report_on_site_waf_events_source',
  reportOnSiteWafEventsStats: 'report_on_site_waf_events_stats',
  reportOnSiteWafEventsTime: 'report_on_site_waf_events_time',
  reportOnSiteWafFirewallEventsDeprecated: 'report_on_site_waf_firewall_events_deprecated',
  createSiteTemplate: 'create_site_template',
  listSites: 'list_sites',
  createSite: 'create_site',
  listAllAvailableSiteLocations: 'list_all_available_site_locations',
  listAvailableGenpopSiteLocations: 'list_available_genpop_site_locations',
  listSiteTemplates: 'list_site_templates',
  createSiteTemplateDeprecated: 'create_site_template_deprecated',
  findSiteTemplate: 'find_site_template',
  deleteSiteTemplate: 'delete_site_template',
  createSiteTemplateSite: 'create_site_template_site',
  listSiteUserSites: 'list_site_user_sites',
  createSiteUser: 'create_site_user',
  siteUserLogin: 'site_user_login',
  resetSiteUserPassword: 'reset_site_user_password',
  modifySiteUser: 'modify_site_user',
  setSiteUserPassword: 'set_site_user_password',
  findSite: 'find_site',
  modifySite: 'modify_site',
  deleteSite: 'delete_site',
  listSiteAccessLogsAliasDeprecated: 'list_site_access_logs_alias_deprecated',
  listSiteAccessLogs: 'list_site_access_logs',
  createSiteAccessToken: 'create_site_access_token',
  disableSiteActivity: 'disable_site_activity',
  enableSiteActivity: 'enable_site_activity',
  listSiteActivityEvents: 'list_site_activity_events',
  createSiteActivityEvent: 'create_site_activity_event',
  findSiteActivityEvent: 'find_site_activity_event',
  deleteSiteActivityEvent: 'delete_site_activity_event',
  findSiteBackupDeprecated: 'find_site_backup_deprecated',
  createSiteBackupDeprecated: 'create_site_backup_deprecated',
  listAutomatedSiteBackups: 'list_automated_site_backups',
  restoreAutomatedSiteBackup: 'restore_automated_site_backup',
  restoreAutomatedSiteBackupDatabase: 'restore_automated_site_backup_database',
  restoreAutomatedSiteBackupFiles: 'restore_automated_site_backup_files',
  downloadSiteBackupDeprecated: 'download_site_backup_deprecated',
  deleteSiteBackupDeprecated: 'delete_site_backup_deprecated',
  restoreSiteBackupDeprecated: 'restore_site_backup_deprecated',
  purgeSiteCachePartial: 'purge_site_cache_partial',
  purgeSiteCacheEverything: 'purge_site_cache_everything',
  callSiteCliDeprecated: 'call_site_cli_deprecated',
  cloneSite: 'clone_site',
  listSiteCloudBackups: 'list_site_cloud_backups',
  createSiteCloudBackup: 'create_site_cloud_backup',
  findSiteCloudBackup: 'find_site_cloud_backup',
  deleteSiteCloudBackup: 'delete_site_cloud_backup',
  downloadSiteCloudBackup: 'download_site_cloud_backup',
  restoreSiteCloudBackup: 'restore_site_cloud_backup',
  findSiteCredentials: 'find_site_credentials',
  listSiteDomains: 'list_site_domains',
  createSiteDomain: 'create_site_domain',
  deleteSiteDomain: 'delete_site_domain',
  findSiteDomainEdgeSettings: 'find_site_domain_edge_settings',
  modifySiteDomainEdgeSettings: 'modify_site_domain_edge_settings',
  listSiteFeaturedPlugins: 'list_site_featured_plugins',
  listSiteFileManagerFiles: 'list_site_file_manager_files',
  listSiteFilesDeprecated: 'list_site_files_deprecated',
  createSiteFile: 'create_site_file',
  updateSiteFile: 'update_site_file',
  deleteSiteFile: 'delete_site_file',
  chmodSiteFile: 'chmod_site_file',
  createSiteFilesArchive: 'create_site_files_archive',
  downloadSiteFile: 'download_site_file',
  extractSiteFile: 'extract_site_file',
  createSiteFileFolder: 'create_site_file_folder',
  viewSiteFile: 'view_site_file',
  listSiteFtpAccounts: 'list_site_ftp_accounts',
  createSiteFtpAccount: 'create_site_ftp_account',
  modifySiteFtpAccount: 'modify_site_ftp_account',
  deleteSiteFtpAccount: 'delete_site_ftp_account',
  lockSite: 'lock_site',
  unlockSite: 'unlock_site',
  findSiteMaindomain: 'find_site_maindomain',
  createSiteMaindomain: 'create_site_maindomain',
  updateSiteMaindomain: 'update_site_maindomain',
  modifySiteMaindomain: 'modify_site_maindomain',
  findSiteMaindomainEdgeSettings: 'find_site_maindomain_edge_settings',
  modifySiteMaindomainEdgeSettings: 'modify_site_maindomain_edge_settings',
  switchSiteMaindomainPrefix: 'switch_site_maindomain_prefix',
  recheckSiteMaindomain: 'recheck_site_maindomain',
  checkSiteMaindomainStatus: 'check_site_maindomain_status',
  findSitePasswordProtection: 'find_site_password_protection',
  enableSitePasswordProtection: 'enable_site_password_protection',
  disableSitePasswordProtection: 'disable_site_password_protection',
  listSitePasswordProtectionUsers: 'list_site_password_protection_users',
  createSitePasswordProtectionUser: 'create_site_password_protection_user',
  deleteSitePasswordProtectionUser: 'delete_site_password_protection_user',
  listSitePlugins: 'list_site_plugins',
  installSitePlugin: 'install_site_plugin',
  updateSitePlugin: 'update_site_plugin',
  togglePluginStatus: 'toggle_plugin_status',
  deleteSitePlugin: 'delete_site_plugin',
  installSiteCdnCacheManagementPlugin: 'install_site_cdn_cache_management_plugin',
  searchSitePlugins: 'search_site_plugins',
  generateSitePmaLogin: 'generate_site_pma_login',
  reportOnSiteBandwidth: 'report_on_site_bandwidth',
  reportOnSiteBandwidthUsage: 'report_on_site_bandwidth_usage',
  reportOnSiteCdnRequestVolumeBySource: 'report_on_site_cdn_request_volume_by_source',
  reportOnSiteTotalRequests: 'report_on_site_total_requests',
  findSiteSettings: 'find_site_settings',
  modifySiteSettings: 'modify_site_settings',
  findSiteSettingsSchema: 'find_site_settings_schema',
  listSiteShopShields: 'list_site_shop_shields',
  enableSiteShopShield: 'enable_site_shop_shield',
  findSiteShopShield: 'find_site_shop_shield',
  disableSiteShopShield: 'disable_site_shop_shield',
  listSiteSshKeys: 'list_site_ssh_keys',
  createSiteSshKey: 'create_site_ssh_key',
  deleteSiteSshKey: 'delete_site_ssh_key',
  authorizeSiteSshKey: 'authorize_site_ssh_key',
  deauthorizeSiteSshKey: 'deauthorize_site_ssh_key',
  findSiteSshKey: 'find_site_ssh_key',
  listSiteSslCertificates: 'list_site_ssl_certificates',
  createSiteSslCertificate: 'create_site_ssl_certificate',
  findSiteSslCertificate: 'find_site_ssl_certificate',
  deleteSiteSslCertificate: 'delete_site_ssl_certificate',
  createSiteStaging: 'create_site_staging',
  deleteSiteStaging: 'delete_site_staging',
  publishSiteStaging: 'publish_site_staging',
  listSiteTasks: 'list_site_tasks',
  cancelSiteTask: 'cancel_site_task',
  listSiteThemes: 'list_site_themes',
  installSiteTheme: 'install_site_theme',
  updateSiteTheme: 'update_site_theme',
  toggleSiteTheme: 'toggle_site_theme',
  deleteSiteTheme: 'delete_site_theme',
  searchSiteThemes: 'search_site_themes',
  transferSite: 'transfer_site',
  acceptSiteTransfer: 'accept_site_transfer',
  cancelSiteTransfer: 'cancel_site_transfer',
  rejectSiteTransfer: 'reject_site_transfer',
  findSiteUsage: 'find_site_usage',
  listSiteUsers: 'list_site_users',
  inviteSiteUser: 'invite_site_user',
  acceptSiteUserInviteWhileLoggedIn: 'accept_site_user_invite_while_logged_in',
  acceptSiteUserInviteForSite: 'accept_site_user_invite_for_site',
  deleteSiteUser: 'delete_site_user',
  reinviteSiteUser: 'reinvite_site_user',
  listSiteVisitors: 'list_site_visitors',
  generateSiteWpLoginLink: 'generate_site_wp_login_link',
  findSiteWpStatus: 'find_site_wp_status',
  callSiteWpcli: 'call_site_wpcli',
  listAccountUsers: 'list_account_users',
  createAccountUser: 'create_account_user',
  acceptAccountUserInvite: 'accept_account_user_invite',
  generateAccountUserRandomPassword: 'generate_account_user_random_password',
  checkAccountUsersPasswordStrength: 'check_account_users_password_strength',
  findAccountUser: 'find_account_user',
  modifyAccountUser: 'modify_account_user',
  deleteAccountUser: 'delete_account_user',
  setAccountUserPassword: 'set_account_user_password',
  reinviteAccountUser: 'reinvite_account_user',
};
